import { createSelector } from 'reselect';

import { coworkingFlexibleWorkplaceWithErrorSelector } from './coworkingFlexibleWorkplaceWithErrorSelector';

export const coworkingFlexibleWorkplaceCountSelector = createSelector(
  coworkingFlexibleWorkplaceWithErrorSelector,
  flexible => flexible.count,
);
